import React from 'react'
import { DialogBox } from '@softura/fluentuipackage'
import './Dialog.scss'

interface IProps {
  hideDialog?: any,
  onDismiss?: any,
  dialogContentProps?: any
}
const DialogContainer = ({ hideDialog, onDismiss, dialogContentProps }:IProps) => {
  return (<>
    <DialogBox hideDialog={hideDialog} onDismiss={onDismiss} dialogContentProps={dialogContentProps} data-attribute="index_Default_DialogBox">
    </DialogBox>
    </>
  )
}

export default DialogContainer
